const absence_kind_options = [
  { label: "Urlop", value: "vacation" },
  {
    label: "Urlop na żądanie",
    value: "vacation_on_request",
  },
  { label: "Chorobowe planowane", value: "sick_leave" },
  { label: "Chorobowe nieplanowane", value: "sick_leave_not_planned" },
];

export default absence_kind_options;
